import { Injectable, signal } from "@angular/core";
import { ApiService } from "../services/api.service";
import { from, map, Observable, Subject, switchMap, takeUntil, tap } from "rxjs";
import { pollerTimer } from "./pollerTimer";
import { toSignal } from '@angular/core/rxjs-interop';
import { SessionProgress } from "../models/session";

@Injectable({
  providedIn: 'root'
})
export class ProgressPoller {
  private TIME_FRAME: number = 2500;

  private uuid: string = '';

  private start$ = new Subject<number>();
  private stop$ = new Subject<void>();
  private _isRunning: boolean = false;

  private progressExecution$ = this.start$.pipe(
    tap(() => this.pollingStatusSignal.set('polling')),
    switchMap(v => {
      return this.pollProgressExecution()
    })
  )

  get isRunning(): boolean {
    return this._isRunning;
  }

  pollingStatusSignal = signal<'polling' | 'not_polling'>('not_polling');
  progressExecution = toSignal(this.progressExecution$);

  constructor(private apiService: ApiService) {

  }

  startPolling(uuid: string): void {
    if (!this._isRunning) {
      this.uuid = uuid;
      this.start$.next(this.TIME_FRAME);
      this._isRunning = true;
    }
  }

  stopPolling(): void {
    this.stop$.next();
    this._isRunning = false;
    this.pollingStatusSignal.set('not_polling');
  }


  // make this private so it can only be started internally
  getProgressExecution(): Observable<SessionProgress[]> {
    return this.apiService.getProgressExecution(this.uuid).pipe(
      map((res) => {
        if (res.length === 0) this.stopPolling();
        return res;
      })
    );
  }

  private pollProgressExecution(): Observable<SessionProgress[]> {
    return from(this.getProgressExecution()).pipe(
      pollerTimer(this.TIME_FRAME),
      takeUntil(this.stop$), // takeUntil MUST be the last operator in the chain for it to stop polling
    );
  }
}
